import React from "react";

const RadioGroup = ({ id, label, options, value, onChange, onBlur, error, required = false }) => {
  const handleChange = (e) => {
    onChange({
      target: {
        name: id,
        value: e.target.value
      }
    });
    
    // Trigger blur event to validate immediately on change
    if (onBlur) {
      onBlur({
        target: {
          name: id,
          value: e.target.value
        }
      });
    }
  };

  return (
    <div className={`form-group radio-group ${error ? 'has-error' : ''}`}>
      {label && (
        <label className="form-label">
          {label}
          {required && <span className="required-indicator">*</span>}
        </label>
      )}
      <div className={`radio-options ${error ? 'error' : ''}`}>
        {options.map((option) => (
          <div className="radio-option" key={option.key}>
            <input
              type="radio"
              id={`${id}_${option.key}`}
              name={id}
              value={option.key}
              checked={value === option.key}
              onChange={handleChange}
              required={required}
            />
            <label htmlFor={`${id}_${option.key}`}>{option.value}</label>
          </div>
        ))}
      </div>
      {error && (
        <p className="error-msg">
          <i className="icon-attention"></i> {error.message}
        </p>
      )}
    </div>
  );
};

export default RadioGroup; 